import React from 'react';
import { Card, Typography, Button, Space, Row } from 'antd';
import {UserRound} from 'lucide-react';
import { getAge } from '../../../utils/datetime';
import {stringMixin, money} from '../../../utils/strings';
const { Text, Title } = Typography;

const EditableSection = ({ title, value, step, onEdit }) => (
  <div className="space-y-2 py-2 border-b">
    <div className="flex justify-between items-center">
      <Text className="font-medium" style={{ fontSize: '1rem' }}>
        {title}
      </Text>
      <Button
        type="link"
        className="text-blue-600"
        onClick={() => onEdit(step)}
      >
        Edit
      </Button>
    </div>
      <div className="ml-2">
        <Text className="text-gray-800" style={{ whiteSpace: 'pre-wrap' }}>
          {value}
        </Text>
      </div>
  </div>
);

const PathSummary = ({ state, setCurrentStep }) => {
  return (
    <Card bordered={false} className={'bg-transparent'}>
      <div className="space-y-6">
        <div className="flex items-center justify-between mb-6">
          <Title level={3} className="font-normal">
            Investment Profile
          </Title>
        </div>

        <div className="grid gap-6">
          {state?.info?.name !== null && (
              <EditableSection title={'Info'}
                               value={<Space direction={'vertical'} style={{width:'100%'}}>
                                 <Space>
                                   <UserRound size={24}/>
                                   <Text>{state?.info?.name}</Text>
                                 </Space>
                                 <Row justify={'space-between'}>
                                   <Text>Born</Text>
                                   <Text>{state?.info?.birthYear?.getFullYear?.()}</Text>
                                 </Row>
                                 <Row justify={'space-between'}>
                                   <Text>Capital</Text>
                                   <Text>{state?.info?.initialValue && money(state?.info?.initialValue || 0, 0)}</Text>
                                 </Row>
                                 <Row justify={'space-between'}>
                                   <Text>Risk Score</Text>
                                   <Text>{state?.info?.riskalyzeScore??'--'}</Text>
                                 </Row>
                               </Space>}
                               step={0}
                               onEdit={setCurrentStep}
              />
          )}
          {state.targetAllocation !== null && (
            <EditableSection
              title="Target Allocation"
              value={`${state.targetAllocation} / ${100 - state.targetAllocation}`}
              step={1}
              onEdit={setCurrentStep}
            />
          )}

          {/*{state.assetClasses?.length > 0 && (*/}
          {/*  <EditableSection*/}
          {/*    title="Asset Classes"*/}
          {/*    value={state.assetClasses.join('\n')} // This ensures values are separated by line breaks*/}
          {/*    step={1}*/}
          {/*    onEdit={setCurrentStep}*/}
          {/*  />*/}
          {/*)}*/}

          {state.useGlobal !== null && (
            <EditableSection
              title="Use Global"
              value={state.useGlobal}
              step={2}
              onEdit={setCurrentStep}
            />
          )}

          {state.includeGold !== null && (
            <EditableSection
              title="Include Gold"
              value={state.includeGold}
              step={3}
              onEdit={setCurrentStep}
            />
          )}
          {state.includeBitcoin !== null && (
            <EditableSection
              title="Include Bitcoin"
              value={state.includeBitcoin ? 'Yes' : 'No'}
              step={4}
              onEdit={setCurrentStep}
            />
          )}
          {state.incomeFocus !== null && (
            <EditableSection
              title="Added Focus"
              value={`Income Focus: ${state.incomeFocus}`}
              step={5}
              onEdit={setCurrentStep}
            />
          )}

          {/*{state.regionOptions?.length > 0 && (*/}
          {/*  <EditableSection*/}
          {/*    title="Assets by Region"*/}
          {/*    value={state.regionOptions.join('\n')} // Each region is listed on a new line*/}
          {/*    step={3}*/}
          {/*    onEdit={setCurrentStep}*/}
          {/*  />*/}
          {/*)}*/}

          {state.leanPortfolio !== null && (
            <EditableSection
              title="Style Preference"
              value={['Strong Value', 'Value', 'Neutral', 'Growth', 'Strong Growth'][state.leanPortfolio + 2]}
              step={4}
              onEdit={setCurrentStep}
            />
          )}
        </div>
      </div>
    </Card>
  );
};

export default PathSummary;
